"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  dangerouslySetInnerHTML: {
    __html: "<path d=\"M8 11c-.949.316-.948.317-.948.317v.003l.002.005.005.014a2.343 2.343 0 00.063.165 6.4 6.4 0 00.985 1.636C8.86 14.044 10.119 15 12 15c1.881 0 3.14-.956 3.893-1.86a6.398 6.398 0 00.985-1.636 3.868 3.868 0 00.063-.165l.005-.014.001-.005.001-.003L16 11c-.949-.316-.948-.318-.948-.318v-.001l.001-.002-.004.01a3.734 3.734 0 01-.147.332 4.394 4.394 0 01-.545.839C13.86 12.456 13.119 13 12 13c-1.119 0-1.86-.544-2.357-1.14a4.395 4.395 0 01-.692-1.17l-.004-.01v.001l.001.002L8 11z\" fill=\"#000\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M2.015 21.985l5.92-.845A9.965 9.965 0 0012 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12c0 1.447.307 2.823.86 4.064l-.845 5.921zm2.907-6.208l-.234-.526A7.965 7.965 0 014 12a8 8 0 118 8 7.966 7.966 0 01-3.25-.688l-.527-.234-3.851.55.55-3.851z\" fill=\"#000\"></path>"
  },
  viewBox: "0 0 24 24",
  fill: "none"
};
exports["default"] = _default;